export default __webpack_public_path__ + "static/media/carouselImage1_1.7cd4c025.png";